import { Formats } from '@utils/intl';
import { BOOKING_TYPE_FREE_SPACES_ROOM } from '@views/shared/consts';
import { useBaseValuesWithArea } from '@views/Home/Book/BasicBook/hooks';

export default function useValues(formats: Formats, message: string) {
  const result = useBaseValuesWithArea({
    formats,
    message,
    type: BOOKING_TYPE_FREE_SPACES_ROOM,
  });

  return {
    ...result,
    hasNextDaysBooking: true,
  };
}
